import { MMButton } from '@components'
import LabelValue from '@components/LabelValue'
import WarningMessage from '@components/WarningMessage'
import { findCurrencyPrecision, formatFloat, formatMoney, tr } from 'mmfintech-commons'
import { QRCodeSVG } from 'qrcode.react'
import { CryptoPreviewTitle, CryptoPreviewWrapper } from './PreviewCrypto.styled'

type PreviewCryptoProps = {
  data: any
  onClose?: () => void
  onBack?: () => void
}

export const PreviewCrypto = ({ data, onClose, onBack }: PreviewCryptoProps) => {
  const { address, currency, tag, processingAmount } = data || {}

  return (
    <>
      <CryptoPreviewWrapper>
        <CryptoPreviewTitle>{tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.TITLE', 'Details')}</CryptoPreviewTitle>

        <LabelValue
          label={tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.ADDRESS', 'Deposit address')}
          value={address}
          enableCopy={true}
          dataTest='address'
        />

        <p className='text-center code bordered'>
          <QRCodeSVG value={address} size={150} />
        </p>

        <LabelValue
          label={tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.TAG', 'Tag')}
          value={tag}
          dataTest='tag'
          enableCopy={true}
        />

        <LabelValue
          label={tr('FRONTEND.BANKING.COMMON.AMOUNT_LABEL', 'Amount')}
          value={formatMoney(processingAmount, currency)}
          dataTest='amount'
          enableCopy={true}
          copyValue={formatFloat(processingAmount, findCurrencyPrecision(currency))}
        />

        <div className='mb-2' />

        {Boolean(onClose) && (
          <MMButton
            type='button'
            variant='primary'
            caption={tr('FRONTEND.BUTTONS.CLOSE', 'Close')}
            onClick={onClose}
            data-test='button-close'
            fullWidth
          />
        )}
        {Boolean(onBack) && (
          <MMButton
            type='button'
            variant='primary'
            caption={tr('FRONTEND.BUTTONS.BACK', 'Back')}
            onClick={onBack}
            data-test='button-back'
            fullWidth
          />
        )}
      </CryptoPreviewWrapper>

      <WarningMessage currency={currency} />
    </>
  )
}
